// this is the unified generic-interactive subsystem you can find state + page management for CJC custom components here
import { tabMenue } from "./generic-interactive-tabs.js"
import { dropdownInfoMenue } from "./generic-interactive-info-dropdowns.js"
import { genericGallery } from "./generic-interactive-gallery.js?v=3";
import { genericModal } from "./generic-interactive-modal.js";

class GenericInteractiveSubsytem {
    pageMenues = new Map();
    segments = [];
    
    constructor(){
        console.log("Generic-Interactive Subsystem Loaded");
        
        // Map attributes to logic classes in this hashmap
        this.pageMenues.set("[generic-tabs]", tabMenue);
        this.pageMenues.set("[generic-dropdown]", dropdownInfoMenue);
        this.pageMenues.set("[generic-gallery]", genericGallery);
        this.pageMenues.set("[generic-modal]", genericModal);

        for(let [attribute, classType] of this.pageMenues){
            // get parts of page by attribute
            let currentSegmentsByType = document.querySelectorAll(attribute);

            // create class of type ( init functionalility ), push to segments list ( any future uses )
            for(let currentSegmentOfType of currentSegmentsByType){
                this.segments.push(new classType(currentSegmentOfType));
                console.log(`found ${attribute} element, binding module ${classType.name}`);        
            }
        }
    }

}

new GenericInteractiveSubsytem();
